import { getShippingSearch } from "../../../api/divvy-shippingSearch";

const shippingSearch = {
  namespaced: true,
  state: () => ({
    shippingSearch: [],
  }),
  getters: {
    allShippingSearch: (state) => state.shippingSearch,
  },
  actions: {
    fetchShippingSearch({ commit }, data) {
      console.log(data, "from fetchShippingSearch");
      return new Promise((resolve, reject) => {
        getShippingSearch(data)
          .then((resp) => {
            commit("SET_SHIPPING_SEARCH", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, " error from getShippingSearch");
          });
      });
    },
  },
  mutations: {
    SET_SHIPPING_SEARCH(state, data) {
      state.shippingSearch = data;
    },
  },
};

export default shippingSearch;
